import BalanceIcon from '@mui/icons-material/Balance';
import { MenuItem } from '@src/common/components/Menu';
import { useToast } from '@src/common/hooks/useToast';
import {
  actionIconStyle,
  menuItemStyle,
} from '@src/orders/components/permitList/PermitActions/PermitActionsStyles';
import {
  DuplicationTrigger,
  useDuplicatePermitAsNew,
} from '@src/orders/hooks/useDuplicatePermitAsNew';
import { useRefreshOrder } from '@src/orders/hooks/useRefreshOrder';
import { useRefreshOrders } from '@src/orders/hooks/useRefreshOrders';
import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

interface Props extends ComponentPropsWithoutRef<typeof MenuItem> {
  permitId: string;
  orderId: string;
}
export const ModifyWithJurisdiction = forwardRef<HTMLLIElement, Props>(
  ({ permitId, orderId, ...menuItemProps }, ref) => {
    const { t } = useTranslation();
    const { refreshOrders } = useRefreshOrders();
    const { refreshOrder } = useRefreshOrder({ id: orderId });
    const { showSuccessToast, showErrorToast } = useToast();
    const { duplicateAsNew } = useDuplicatePermitAsNew({
      permitApplicationId: permitId,
      onSuccess: () => {
        showSuccessToast(t('permitApplication.modifyWithSuccess'));
        refreshOrder();
        refreshOrders();
      },
      onError: () => showErrorToast(t('permitApplication.modifyWithError')),
    });

    const handleModifyWithJurisdictionPermitClick = () => {
      duplicateAsNew({
        trigger: DuplicationTrigger.MODIFY,
      });
    };
    return (
      <>
        <MenuItem
          {...menuItemProps}
          ref={ref}
          className={menuItemStyle}
          onClick={() => handleModifyWithJurisdictionPermitClick()}
        >
          <BalanceIcon style={actionIconStyle} />
          {t('permitApplication.modify')}
        </MenuItem>
      </>
    );
  },
);
